import { notesReqApprovalActions, patientActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    loading: false
};

export const reducer = createReducer(initialState, {
    [notesReqApprovalActions.loadPdfRequest]: (state, action) => {
        state.loading = true;
    },
    [notesReqApprovalActions.loadPdfSuccess]: (state, action) => {
        state.loading = false;
    },
    [notesReqApprovalActions.loadPdfFailure]: (state, action) => {
        state.loading = false;
    },
    [patientActions.loadPdfRequest]: (state, action) => {
        state.loading = true;
    },
    [patientActions.loadPdfSuccess]: (state, action) => {
        state.loading = false;
    },
    [patientActions.loadLimberPdfSuccess]: (state, action) => {
        state.loading = false;
    },
    [patientActions.loadPdfFailure]: (state, action) => {
        state.loading = false;
    }

})


